import { MAX_ATTENDEE_COUNT } from 'common/util/validators/minutes-properties/minutes-properties-validators'
import i18n from 'i18next'

export { MAX_ATTENDEE_COUNT }

export interface AttendeeData {
    id: string | number
    external_id?: string | number | null
    text?: string
    name?: string
    email?: string | null
    value?: string
    isTimeLate?: boolean
    isLocationRemote?: boolean
}

export type SectionType = 'invited' | 'present' | 'absent'

export interface ContactAttributes {
    displayName: string
    email: string
}

export interface ContactData {
    id: string
    attributes: ContactAttributes
}

export interface AllContacts {
    [key: string]: ContactData
}

export const getValidId = (attendee: AttendeeData): string | number => {
    return attendee.id || `fallback_${attendee.name || attendee.text || 'unknown'}`
}

export const mapAttendeeForChip = (attendee: AttendeeData) => ({
    ...attendee,
    email: attendee.email || null,
    id: attendee.id,
    external_id: attendee.external_id,
    value: attendee.value || attendee.text || attendee.name
})

export const filterAttendeeFromList = (
    attendees: AttendeeData[],
    attendeeToRemove: AttendeeData
): AttendeeData[] => {
    return attendees.filter((item) => {
        if (item.id === attendeeToRemove.id) {
            return false
        }
        const itemName = (item.name || item.text || '').trim().replace(/\s+/g, ' ').toLowerCase()
        const attendeeName = (attendeeToRemove.name || attendeeToRemove.text || '')
            .trim()
            .replace(/\s+/g, ' ')
            .toLowerCase()
        return itemName !== attendeeName
    })
}

export const isForwardMove = (fromSection: SectionType, toSection: SectionType): boolean => {
    const sectionOrder: SectionType[] = ['invited', 'present', 'absent']
    const fromIndex = sectionOrder.indexOf(fromSection)
    const toIndex = sectionOrder.indexOf(toSection)
    return toIndex > fromIndex
}

export const validateAttendeeCount = (count: number): string | null => {
    if (count >= MAX_ATTENDEE_COUNT) {
        return (
            i18n.t('INVALID_ATTENDEE_COUNT', { count: MAX_ATTENDEE_COUNT }) ||
            `Maximum ${MAX_ATTENDEE_COUNT} attendees allowed`
        )
    }
    return null
}

export const createNewAttendee = (section: SectionType, name: string): AttendeeData => ({
    id: `custom_${section}_${Date.now()}`,
    text: name,
    name: name,
    email: null
})

export const normalizeAttendee = (attendee: AttendeeData): AttendeeData => ({
    id: attendee.id || `cross_${Date.now()}`,
    external_id: attendee.external_id,
    text: attendee.text || attendee.name || 'Unknown',
    name: attendee.name || attendee.text || 'Unknown',
    email: attendee.email || null,
    isTimeLate: attendee.isTimeLate,
    isLocationRemote: attendee.isLocationRemote
})
